import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const Solution = () => {
  const { t } = useLang();
  const steps = t("solution.steps");
  return (
    <section className="relative py-32 lg:py-48 bg-[#050B1B]" data-testid="solution-section">
      <div className="container-sat">
        <div className="max-w-3xl mb-20">
          <div className="overline mb-6">{t("solution.overline")}</div>
          <h2 className="headline-xl text-4xl md:text-5xl lg:text-7xl">
            {t("solution.title")}
          </h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent"></div>

          <div className="space-y-16 md:space-y-28">
            {steps.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <div key={i} className="grid md:grid-cols-2 gap-8 md:gap-20 items-center" data-testid={`solution-step-${i}`}>
                  <div className={`${left ? "md:order-1" : "md:order-2"} ${left ? "md:text-right" : ""}`}>
                    <div className={`flex items-baseline gap-4 ${left ? "md:justify-end" : ""}`}>
                      <span className="serif italic text-5xl md:text-6xl text-[#D4AF37]/80 leading-none">{s.n}</span>
                      <h3 className="serif text-3xl md:text-5xl font-light">{s.t}</h3>
                    </div>
                    <p className="text-white/70 mt-6 max-w-md text-lg leading-relaxed">
                      {s.d}
                    </p>
                  </div>
                  <div className={`relative h-32 md:h-40 ${left ? "md:order-2" : "md:order-1"}`}>
                    <div className="hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#D4AF37]"></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
